import { Select, SelectProps } from 'components/Select/Select';

import { DATA_POOLS } from 'dashboards/services/data_pool';
import { DataPoolName } from 'dashboards/types/data_pool';

type DataPoolColumnsSelectProps = Omit<
  SelectProps<
    {
      name: string;
    },
    true
  >,
  'value' | 'defaultValue' | 'onChange'
> & {
  dataPool: DataPoolName;
  value?: string[];
  defaultValue?: string[];
  onChange: (value: string[]) => void;
};

export function DataPoolColumnsSelect({
  dataPool,
  value,
  defaultValue,
  onChange,
  ...props
}: DataPoolColumnsSelectProps) {
  return (
    <Select
      {...props}
      value={value?.map((name) => ({ name }))}
      defaultValue={defaultValue?.map((name) => ({ name }))}
      options={DATA_POOLS[dataPool].columns}
      getOptionLabel={({ name }) => name}
      getOptionValue={({ name }) => name}
      onChange={(options) => onChange(options.map(({ name }) => name))}
      isMulti
    />
  );
}
